async function dataCheck(newData, oldData, type) {
  // console.log("the type is: ", type);
  // console.log(newData == null && oldData == null);
  // console.log(!newData && oldData, newData && !oldData);
  return (!newData && oldData) || (newData && !oldData);
}
exports.dataCheck = dataCheck;
